import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { APPLICATION_STATUS, FIRE_SAFETY_APPLICATION } from "tagTypes";

export const useApplicantStatusQuery = (query = {}, isFireSafety = false) =>
  useGetQuery({
    endpoint: isFireSafety
      ? "/building-information-status"
      : "/application-status",
    query,
    tags: [APPLICATION_STATUS, FIRE_SAFETY_APPLICATION],
  });

export const useLazyApplicantStatusQuery = () => {
  const [getApplicantStatus, data] = useLazyGetQuery();
  const applicantStatus = async (query = {}) =>
    await getApplicantStatus({
      endpoint: "/application-status",
      query,
      tags: [APPLICATION_STATUS],
    }).unwrap();
  return [applicantStatus, data];
};

export const usePostApplicantStatusMutation = () => {
  const [applicantStatus, data] = usePostMutation();
  const addApplicantStatus = async (payload, query = {}) =>
    await applicantStatus({
      endpoint: "/application-status",
      query,
      payload: payload || {},
      toastMessage: "Applicant status added successfully",
      tags: [APPLICATION_STATUS],
    }).unwrap();
  return [addApplicantStatus, data];
};

export const usePutApplicantStatusMutation = () => {
  const [applicantStatus, data] = usePutMutation();
  const updateApplicantStatus = async (payload, id, query = {}) =>
    await applicantStatus({
      endpoint: `/application-status/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Applicant status updated successfully",
      tags: [APPLICATION_STATUS],
    }).unwrap();
  return [updateApplicantStatus, data];
};

export const useDeleteApplicantStatusMutation = () => {
  const [applicantStatus, data] = useDeleteMutation();
  const deleteApplicantStatus = async (id, query = {}) =>
    await applicantStatus({
      endpoint: `/application-status/${id}`,
      query,
      toastMessage: "Applicant status deleted successfully",
      tags: [APPLICATION_STATUS],
    }).unwrap();
  return [deleteApplicantStatus, data];
};
